import axios from "./axios";

export const GetFontAwesomeIcons = query => {
  return axios.post(`https://api.fontawesome.com`, {
    query
  });
};
